String.prototype.toProperCase = function() {
  return this.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};


export const nextIndex = (index, routes) => ++index % routes.length

export const indexFromPath = (path, routes) => {
  // defoltais komponents
  // path = path === '/' ? '/home' : path


  // šis noņema beigu /
  // path = (path.slice(-1) === '/' && path.length > 1) ? path.slice(0, -1) : path

  // pielika beigu /
  path = (path.slice(-1) === '/') ? path : path + '/'

  const pages = routes.map(route => route.path)
  return pages.indexOf(path)
}

const thumbSizeRe = /-\d+x\d+(?:.(jpe?g|png|gif))$/
export function getImageUrlFromThumb(src) {
  return src.replace(thumbSizeRe, '.$1')
}




// WEBPACK FOOTER //
// ./src/utils/index.js